module.exports = __webpack_public_path__ + "assets/images/premium-features/messages-banner-new-c3722c.png";